import * as React from 'react'
import {Button} from '@frontrow/console/src/components/button'

type Props = {
  creationFailedReason: string
  resetDemoDistrict: () => void
}

export default function CreationFailedPanel(props: Props): React.ReactElement {
  const {creationFailedReason, resetDemoDistrict} = props
  return (
    <React.Fragment>
      <p>Demo district creation failed! Please contact engineering with the following error:</p>
      <p>{creationFailedReason}</p>
      <p>
        <Button onClick={resetDemoDistrict}>Try again</Button>
      </p>
    </React.Fragment>
  )
}
